import React from 'react';
import ApplicationCard from "../../ApplicationCard/ApplicationCard";

type GodtattCardProps = {
    barnNavn: string;
}

const GodtattCard = ({ barnNavn }: GodtattCardProps) => {
    return (
        <ApplicationCard title={barnNavn} variant={"grønn"}>
            <div className={"pkt-txt-16-light"}>
                Du har takket ja til tilbudet om barnehageplass.
            </div>
            <div className={"pkt-txt-16-light"}>
                Ønsker du å sette deg på venteliste til andre barnehager? Det gjør du ved å sende inn en ny søknad. Du må vente til svaret på dette tilbudet er behandlet. Det tar vanligvis et par dager.
            </div>
        </ApplicationCard>
    );
};

export default GodtattCard;